import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: import.meta.env.VITE_HOME,
        name: 'home',
        component: () => import('./components/Pages/HomeScreen.vue'),
    },
    {
        path: import.meta.env.VITE_PRIVACY,
        name: 'privacy',
        component: () => import('./components/Pages/PrivacyNotice.vue'),
    },
    {
        path: import.meta.env.VITE_UNAUTHORIZED,
        name: 'unauthorized',
        component: () => import('./components/Pages/UnauthorizedError.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
})


export default router;